import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { Observable } from 'rxjs/Observable';
import { DetailedEntityBackendService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { ReportsConfigurationDataService } from './reports-configuration-data.service';
import { HttpHeaders } from '@angular/common/http';
import { LoaderEnabled } from 'sce-core';

@Injectable()
export class ReportsConfigurationBackendService extends DetailedEntityBackendService {

  protected dataService: ReportsConfigurationDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  // service call to save an entity detail while creating
  //LFWM-2812- LoaderEnabled is added
  @LoaderEnabled()   
  public saveEntityforAdd(entityNumber: any, entityProperties: any, lineItems: any) {
    const request: any[] = [];
    request.push({
      'moduleProperties': entityProperties,
      'screenType': this.dataService.primarySearchParams.tableId,
      'detailItems': [],
    });
    lineItems.forEach((lineItem: any) => {
      request.push({
        'moduleProperties': lineItem.cells,
        'screenType': this.dataService.detailsSearchParams.tableId,
        'detailItems': [],
      });
    });
    const response$ = this.http$.post(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

  // Service call to update an entity
  public saveEntityforUpdate(entityNumber: any, entityProperties: any, lineItems: any) {
    const request: any[] = [];
    request.push({
      'moduleProperties': entityProperties,
      'screenType': this.dataService.primarySearchParams.tableId,
      'detailItems': [],
    });
    lineItems.forEach((lineItem: any) => {
      request.push({
        'moduleProperties': lineItem.cells,
        'screenType': this.dataService.detailsSearchParams.tableId,
        'detailItems': [],
      });
    });
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

  // service call to delete selected line items
  public deleteSelectedLineItem(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete(`api/setup/`, options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        // return Observable.throw(error.message);
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // service call to delete all line items of an entity
  public deleteAllLineItemsFromEntity(itemNumber: any): Observable<Response> {
    const request = [{
      'screenType': 'wmrepdettd',
      'moduleProperties': [{
        cName: this.dataService.primarySearchParams.idProperty,
        cVal: itemNumber
      }, { cName: 'isDeleteAllItem', 'cVal': true }],
      'detailItems': []
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/services/reports-configuration-backend.service.ts